// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-resource-children-section svg.icon {
  margin: 0 2px;
}
.ngw-resource-children-section .ant-table .displayName {
  width: 100%;
  text-align: left !important;
}
.ngw-resource-children-section .ant-table .displayName > a {
  display: flex;
  align-items: center;
  gap: 8px;
  color: black;
  text-decoration: none;
  overflow-wrap: anywhere;
}
.ngw-resource-children-section .ant-table .displayName > a:hover {
  color: var(--primary);
}
.ngw-resource-children-section .ant-table .displayName > a > svg.icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}
.ngw-resource-children-section .ant-table .actions,
.ngw-resource-children-section .ant-table .volume {
  text-align: right !important;
}
.ngw-resource-children-section .ant-table .actions {
  font-size: 24px;
}
.ngw-resource-children-section .ant-table .cls,
.ngw-resource-children-section .ant-table .ownerUser,
.ngw-resource-children-section .ant-table .volume,
.ngw-resource-children-section .ant-table .actions {
  white-space: nowrap;
}
.ngw-resource-children-section .ant-table .ownerUser {
  max-width: 15em;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/resource/nodepkg/children-section/ChildrenSection.less"],"names":[],"mappings":"AAAA;EAEQ,aAAA;AAAR;AAFA;EAOY,WAAA;EACA,2BAAA;AAFZ;AAIY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;AAFhB;AAIgB;EACI,qBAAA;AAFpB;AAKgB;EACI,cAAA;EACA,WAAA;EACA,YAAA;AAHpB;AAtBA;;EAgCY,4BAAA;AANZ;AA1BA;EAoCY,eAAA;AAPZ;AA7BA;;;;EA2CY,mBAAA;AARZ;AAnCA;EA+CY,eAAA;EACA,gBAAA;EACA,uBAAA;AATZ","sourcesContent":[".ngw-resource-children-section {\n    svg.icon {\n        margin: 0 2px;\n    }\n\n    .ant-table {\n        .displayName {\n            width: 100%;\n            text-align: left !important;\n\n            & > a {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                color: black;\n                text-decoration: none;\n                overflow-wrap: anywhere;\n\n                &:hover {\n                    color: var(--primary);\n                }\n\n                & > svg.icon {\n                    flex-shrink: 0;\n                    width: 24px;\n                    height: 24px;\n                }\n            }\n        }\n\n        .actions,\n        .volume {\n            text-align: right !important;\n        }\n\n        .actions {\n            font-size: 24px;\n        }\n\n        .cls,\n        .ownerUser,\n        .volume,\n        .actions {\n            white-space: nowrap;\n        }\n\n        .ownerUser {\n            max-width: 15em;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
